<div id="vtz-main-wrapper" class="vtz-main-wrapper">
  <div id="vtz-main-container" class="vtz-main-container vtz-main-container--ballot">
    <div id="vtz-title-section" class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>
    <main id="vtz-welcome-wrapper" class="vtz-welcome-wrapper">
      @switch(aboutService.VWAFlowType) {
        @case("GLOBAL") {          
          <div id="vtz-numbered-list__container" class="vtz-numbered-list__container">
            <app-big-numbered-list-item i18n [num]="1">
              Enter your email and mobile number.
            </app-big-numbered-list-item>
            <app-big-numbered-list-item i18n [num]="2">
              A 6-digit code will be sent to your email. Enter this code into the designated field.
            </app-big-numbered-list-item>
            <app-big-numbered-list-item i18n [num]="3">
              You will be taken to your voter dashboard.
            </app-big-numbered-list-item>
            <app-big-numbered-list-item i18n [num]="4">
              On the dashboard, you can verify your identity by entering an organization's verification key or scanning a QR code (provided by your administrator), OR
            </app-big-numbered-list-item>
            <app-big-numbered-list-item i18n [num]="5">
              If the organization requires photo identification, you can take a selfie and upload photo ID from the dashboard.
            </app-big-numbered-list-item>
            <app-big-numbered-list-item i18n [num]="6">
              When your identity has been confirmed, you will be able to access the ballot(s), petition(s), and/or poll(s) for that organization.
            </app-big-numbered-list-item>
          </div>
        }
        @default {          
          @if(aboutService.hasRegistrationStep && isRegistrationNotOpenYet()) {
            <h3 id="main-title" class="vtz-h1 vtz-text--center" i18n>Registration is not open yet.</h3><br>
            <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
              The voting site will be open from {{registrationStartTimeReadable}} until {{closeTimeReadable}} {{aboutService.localTimeZone}}.
            </p>
          } @else if (!aboutService.hasRegistrationStep && isElectionNotOpenYet()) {
            <h3 id="main-title" class="vtz-h1 vtz-text--center" i18n>The solicitation is not open yet.</h3><br>
            <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
              You can read the TZROP Consent Solicitation Statement <a target="_blank" href="https://storage.googleapis.com/public-disclosures.tzero.com/TZROP-Consent-Solicitation-Statement.pdf">here</a>.
            </p>
            <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
              The voting site will be open from {{startTimeReadable}} until {{closeTimeReadable}} {{aboutService.localTimeZone}}.
            </p>
          } @else {}
    
          @if (isElectionClosed()) {
            <h3 id="main-title" class="vtz-h1 vtz-text--center" i18n>The solicitation is closed.</h3><br>
            <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
              The voting site closed at {{closeTimeReadable}} {{aboutService.localTimeZone}}.
            </p>
          } @else if (aboutService.hasRegistrationStep && isRegistrationClosed()){
            <h3 id="main-title" class="vtz-h1 vtz-text--center" i18n>Registration is closed.</h3><br>
            <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
              Registration for the voting site closed at {{registrationCloseTimeReadable}} {{aboutService.localTimeZone}}.
            </p>
            @if(isElectionNotOpenYet()) {
              <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
                The voting site will be open from {{startTimeReadable}} until {{closeTimeReadable}} {{aboutService.localTimeZone}}.
              </p>
            } @else {
              <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
                The solicitation is still open until {{closeTimeReadable}} {{aboutService.localTimeZone}}.
              </p>
              <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
                Please click "CONTINUE" to enter your Voting Code.
              </p>
            }
          } @else {}
    
          @if(aboutService.hasRegistrationStep && !isRegistrationClosed()){ 
            <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
              You will need to complete the following steps in order to vote:
            </p>
            <div id="vtz-numbered-list__container" class="vtz-numbered-list__container">
              @if(aboutService.idUploadFlow){
                <app-big-numbered-list-item i18n [num]="1">
                  Enter your email and mobile number as they appear on your voter registration.
                </app-big-numbered-list-item>
                <app-big-numbered-list-item i18n [num]="2">
                  A 6-digit code will be sent to your email. Enter this code into the designated field.
                </app-big-numbered-list-item>
                <app-big-numbered-list-item i18n [num]="3">
                  If your identity has already been confirmed, you will be taken to your voter dashboard to vote. Otherwise, proceed to Steps 4-6.
                </app-big-numbered-list-item>
                <app-big-numbered-list-item i18n [num]="4">
                  Upload or take a snapshot of your official photo ID.
                </app-big-numbered-list-item>
                <app-big-numbered-list-item i18n [num]="5">
                  Take a selfie with your device camera.
                </app-big-numbered-list-item>
                <app-big-numbered-list-item i18n [num]="6">
                  When your identity has been confirmed, you will be able to access your ballot.
                </app-big-numbered-list-item>
              } @else {
                <app-big-numbered-list-item i18n [num]="1">
                  Enter your Registration Code and date of birth as it appears on your voter registration and provide an email or mobile number to receive your Voting Code.
                </app-big-numbered-list-item>
                <app-big-numbered-list-item i18n [num]="2">
                  Retrieve the 11-character Voting Code sent to you and enter it into the designated field, along with your date of birth.
                </app-big-numbered-list-item>
                <app-big-numbered-list-item i18n [num]="3">
                  Voters with disabilities or who are living overseas may choose to return their ballot electronically. If so, Steps 5 and 6 are unnecessary.
                </app-big-numbered-list-item>
                <app-big-numbered-list-item i18n [num]="4">
                  You can mark the ballot online or continue to print a blank ballot.
                </app-big-numbered-list-item>
                <app-big-numbered-list-item i18n [num]="5">
                  Download and print your Printing Kit that contains your marked ballot and 3 envelopes.
                </app-big-numbered-list-item>
                <app-big-numbered-list-item i18n [num]="6">
                  Follow the instructions provided to prepare and mail your ballot. Be sure to sign the affidavit on the inner envelope.
                </app-big-numbered-list-item>
              }
            </div>
          } @else if(!isElectionClosed()){
            <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
              You can read the TZROP Consent Solicitation Statement <a target="_blank" href="https://storage.googleapis.com/public-disclosures.tzero.com/TZROP-Consent-Solicitation-Statement.pdf">here</a>.
            </p>
            <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
              The Pro Forma Cap Table is available <a target="_blank" href="https://storage.googleapis.com/public-disclosures.tzero.com/tZERO-Pro-Forma-Capitalization-Table.pdf">here</a>.
            </p>
            <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
              The Note Financing Letter of Intent is available <a target="_blank" href="https://storage.googleapis.com/public-disclosures.tzero.com/tZERO-BBB-LOI.pdf">here</a>.
            </p>
            <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
              Read the Press Release and Supplement dated April 16, 2026 <a target="_blank" href="https://www.tzero.com/news/tzero-enhances-tzrop-conversion-proposal-to-include-participation-in-tzero-common-equity">here</a>.
            </p>
            <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
              You will need to complete the following steps in order to vote:
            </p>
            <div id="vtz-numbered-list__container" class="vtz-numbered-list__container">
              <app-big-numbered-list-item i18n [num]="1">
                Retrieve the Voting Pin sent to your email and enter it into the designated field.
              </app-big-numbered-list-item>
              <app-big-numbered-list-item i18n [num]="2">
                Mark your ballot.
              </app-big-numbered-list-item>
              <app-big-numbered-list-item i18n [num]="3">
                Review your selection and submit.
              </app-big-numbered-list-item>              
            </div>
          } @else {}
    
          @if (!isAdminVersion.value && !isElectionClosed() && aboutService.hasPrintOption) {
            <p
              class="vtz-text vtz-text--center vtz-text--wide vtz-text--bright-blue"
              i18n
              >
              <i>All papers from the Printing Kit will need to be printed on 8.5" x 11" sized paper.</i>
            </p>
          }
        }
      }
      

      @if (aboutService.hasRegistrationStep && isRegistrationLive()) {
        <div  id="vtz-actions" class="vtz-actions">
          <div id="button-group" class="button-group">
            <!-- <div class="vtz-spacer-10"></div> -->
            @if(aboutService.idUploadFlow) {
              <button id="continue-button" 
                i18n
                class="button-primary"
                (click)="toHomeScreen()"
                >
                CONTINUE
              </button>
            } @else {
              <button
                id="start-button"
                i18n
                class="button-primary"
                (click)="toRegistrationScreen()"
                >
                GET STARTED
              </button>
            }
          </div>
        </div>
      } @else if(isElectionLive()) {
        <div  id="vtz-actions" class="vtz-actions">
          <div id="button-group" class="button-group">
            <!-- <div class="vtz-spacer-10"></div> -->
            <button
              id="continue-button"
              i18n
              class="button-primary"
              (click)="toHomeScreen()"
              >
              CONTINUE
            </button>
          </div>
        </div>
      } @else { }
    </main>
  </div>
</div>

@if (isAdminVersion.value) {
  <app-admin-modal [isOpen]="adminVerificationRequired"></app-admin-modal>
}
